import styled, { css } from 'styled-components';
import { getElevationTransition, elevation } from '../Styles/Utils/elevation.js';
import { ChevronIcon } from '../Icons/components/ChevronIcon.js';

const Container = styled.section.withConfig({
    displayName: "styles__Container",
    componentId: "sc-5e0c07f-0"
})`
    position: relative;
`;
const ItemStyles = css`
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: ${({ theme  })=>theme.colors.Foreground};
`;
const ItemText = styled.div.withConfig({
    displayName: "styles__ItemText",
    componentId: "sc-5e0c07f-1"
})`
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
const SelectedItem = styled.div.withConfig({
    displayName: "styles__SelectedItem",
    componentId: "sc-5e0c07f-2"
})`
    ${ItemStyles};
    border-radius: 24px;
    border: 2px solid ${({ theme  })=>theme.colors["Level 1"]};
    ${(props)=>props.isMultiple && css`
            cursor: pointer;
            ${getElevationTransition(true)}
            &:hover {
                ${elevation(3, true)}
            }
            &:active {
                ${elevation(1, true)}
            }
        `}
`;
const Placeholder = styled.div.withConfig({
    displayName: "styles__Placeholder",
    componentId: "sc-5e0c07f-3"
})`
    color: ${({ theme  })=>theme.colors["Level 5"]};
`;
const List = styled.ul.withConfig({
    displayName: "styles__List",
    componentId: "sc-5e0c07f-4"
})`
    top: -3px;
    left: -2px;
    width: 104%;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    background: ${({ theme  })=>theme.colors.ElementBackground};
    border-radius: 24px;
    z-index: 2;
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
    margin: 0;
    padding: 0;
    transform: scale(0.9);
    transform-origin: top center;
    ${elevation(0, false)}

    ${(props)=>props.isOpen && css`
            width: 101%;
            opacity: 1;
            visibility: visible;
            transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
            transform: scale(1);
            ${elevation(3, false)}
        `}
`;
const ListElement = styled.li.withConfig({
    displayName: "styles__ListElement",
    componentId: "sc-5e0c07f-5"
})`
    ${ItemStyles};
    cursor: pointer;
    &:hover {
        background: ${({ theme  })=>theme.colors["Level 1"]};
    }
    transition: background-color ease 0.3s;
    &:first-child {
        border-radius: 20px 20px 0 0;
    }
    &:last-child {
        border-radius: 0 0 20px 20px;
    }
    &:not(:last-child) {
        border-bottom: 2px solid ${({ theme  })=>theme.colors["Level 1"]};
    }
`;
const IconWrap = styled.div.withConfig({
    displayName: "styles__IconWrap",
    componentId: "sc-5e0c07f-6"
})`
    margin-right: 8px;
    display: flex;
`;
const Chevron = styled(ChevronIcon).withConfig({
    displayName: "styles__Chevron",
    componentId: "sc-5e0c07f-7"
})`
    height: 24px;
    width: 24px;
`;

export { Chevron, Container, IconWrap, ItemText, List, ListElement, Placeholder, SelectedItem };
